// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ox6ePPJQmwnNyPjCo7KU{background:var(--background-neutral-subtle);border-radius:8px;flex-direction:column;margin-bottom:16px;padding:16px 16px 18px;display:flex}.k3mnP7tjHLkY3_0NZS3E{background:var(--background-neutral-subtle);border-radius:8px;justify-content:space-between;align-items:center;margin-bottom:34px;padding:20px 16px;display:flex}.Se35utVy1kyYY6wf88Hw{align-items:center;gap:8px;margin:8px 0 20px;display:flex}.JnOCLym6vEQYGuCQY0uA{height:44px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"planHeader": `ox6ePPJQmwnNyPjCo7KU`,
	"planTotal": `k3mnP7tjHLkY3_0NZS3E`,
	"planHeaderTitle": `Se35utVy1kyYY6wf88Hw`,
	"createButton": `JnOCLym6vEQYGuCQY0uA`
};
export default ___CSS_LOADER_EXPORT___;
